export class ImageService {
  static async readImage(file: File): Promise<HTMLImageElement> {
    return new Promise<HTMLImageElement>((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.onload = (evt: ProgressEvent<FileReader>) =>
        resolve(Object.assign(new Image(), { src: evt.target.result }));
      fileReader.onerror = (evt: ProgressEvent<FileReader>) => reject(evt.target.error);
      fileReader.readAsDataURL(file);
    });
  }
}
